import { createAction } from 'redux-actions';
import * as toxProfileItemFormTypes from './toxProfileItemFormTypes';

export const loadForm = createAction(toxProfileItemFormTypes.LOAD_FORM);
export const onSaveButtonClick = createAction(toxProfileItemFormTypes.SAVE_BUTTON_CLICK);
export const addProfileItem = createAction(toxProfileItemFormTypes.ADD_TOXPROFILEITEM);
export const onSelectProfileItem = createAction(toxProfileItemFormTypes.SELECT_TOXPROFILEITEM);
export const onDeleteButtonClick = createAction(toxProfileItemFormTypes.DELETE_BUTTON_CLICK);
